import { Injectable } from '@angular/core';
import { get1 } from 'src/utils/api';
import { ALL_REFERRALS_BUCKET, ALL_REFERRALS_COUNTED_BUCKETS, BucketSummaryItem } from './packet-bucket.models';

@Injectable({ providedIn: 'root' })
export class PacketBucketService {
  private baseUrl = 'api/packets';

  getBucketsSummary(signal?: AbortSignal) {
    return get1(`${this.baseUrl}/buckets-summary`, { signal });
  }

  // Bucket -> count for the Packet Buckets menu (sidebar badges and the bell panel), including
  // All referrals: the sum of ALL_REFERRALS_COUNTED_BUCKETS, which is every bucket the All
  // referrals grid spans — hidden ones included. buckets-summary also returns buckets outside that
  // set (e.g. TBD), which the backend likewise leaves out of the All referrals grid.
  // get1 resolves with the error rather than rejecting, so callers passing a signal should check
  // signal.aborted before using the result.
  async getBucketCounts(signal?: AbortSignal): Promise<Record<string, number>> {
    const res: any = await this.getBucketsSummary(signal);
    const data: BucketSummaryItem[] = res?.data?.data ?? res?.data ?? [];
    const counts: Record<string, number> = Object.fromEntries(data.map((d) => [d.bucket, d.count]));
    counts[ALL_REFERRALS_BUCKET] = ALL_REFERRALS_COUNTED_BUCKETS.reduce((sum, bucket) => sum + (counts[bucket] ?? 0), 0);
    return counts;
  }
}
